import baseURL from "../common/axios";
class ReportsService {
  //To Get Reports Param List
  getReportList() {
    return baseURL.httpMSInventoryUrl.get("Reports/GetReportList");
  }
  //To Get Reports Field List
  getFieldList(paramId) {
    return baseURL.httpMSInventoryUrl.get(
      "Reports/GetFieldsList?ParamId=" + paramId
    );
  }
}
export default new ReportsService();
